export const publisherListsEndpointIds = {
    GET_PUBLISHER_BANNED_CREATORS: 'GET_PUBLISHER_BANNED_CREATORS',
    ADD_PUBLISHER_BANNED_CREATORS: 'ADD_PUBLISHER_BANNED_CREATORS',
    REMOVE_PUBLISHER_BANNED_CREATOR: 'REMOVE_PUBLISHER_BANNED_CREATOR',
    REMOVE_PUBLISHER_BANNED_CREATORS: 'REMOVE_PUBLISHER_BANNED_CREATORS',
};
